(() => {
  const selector = '#CartDrawer .drawer__footer';

  const markup = `
    <div class="bpc-cart-order-info bpc-cart-order-info--drawer" data-bpc-cart-trust aria-label="Order and checkout information">
      <div class="bpc-cart-order-info__facts">
        <span class="bpc-cart-order-info__fact">Checkout is charged in USD.</span>
        <span class="bpc-cart-order-info__fact">Free standard shipping worldwide.</span>
        <span class="bpc-cart-order-info__fact">Made to order: production normally takes 2–5 business days.</span>
      </div>
      <small class="bpc-cart-order-info__note">
        Eligible duties and import taxes are prepaid for US and EU orders; destination charges may apply elsewhere.
        <a href="/policies/shipping-policy">Shipping Policy</a>
        <span aria-hidden="true">·</span>
        <a href="/policies/refund-policy">Refund Policy</a>
      </small>
    </div>`;

  function ensureCartTrust() {
    const footer = document.querySelector(selector);
    if (!footer || footer.querySelector('[data-bpc-cart-trust]')) return;

    const checkout = footer.querySelector('.cart__ctas');
    if (!checkout) return;

    const template = document.createElement('template');
    template.innerHTML = markup.trim();
    checkout.before(template.content.firstElementChild);
  }

  let queued = false;
  function queueEnsure() {
    if (queued) return;
    queued = true;
    window.requestAnimationFrame(() => {
      queued = false;
      ensureCartTrust();
    });
  }

  document.addEventListener('DOMContentLoaded', ensureCartTrust);
  document.addEventListener('shopify:section:load', queueEnsure);

  const observer = new MutationObserver(queueEnsure);
  observer.observe(document.documentElement, { childList: true, subtree: true });

  ensureCartTrust();
})();
